import { makeStyles } from '@material-ui/core';
import React from 'react';
import TabLink from '../../../components/common/tabLink';
import Footer from '../../../components/footer';
import Header from '../../../components/header';
import { COLORS } from '../../../constants/colors';
import { selectValues } from '../../../constants/roles';
import { useUser } from '../../../hooks';

const useStyles = makeStyles({
  header: {
    height: '100%',
    width: 'fit-content',
    display: 'flex',
    justifyContent: 'space-between',
    '@media (max-width:900px)': {
      width: '10.5625rem',
    },
  },
  body: {
    minHeight: '67.7vh',
    backgroundColor: COLORS.grayScale[2],
  },
  separator: {
    width: '5px',
    height: '5px',
    backgroundColor: COLORS.primary.main,
    borderRadius: '50%',
    margin: 'auto 10px'
  }
});

const PrivatePage = ({ children }) => {
  const classes = useStyles();
  const { user } = useUser();

  return (
    <>
      <Header>
        <div className={classes.header}>
          <TabLink to="/candidates" label="Candidates" />
          <div className={classes.separator}/>
          <TabLink to="/skills" label="Skills" />
          <div className={classes.separator}/>
          <TabLink to="/candidateRoles" label="Roles" />
          <div className={classes.separator}/>
          <TabLink to="/reports" label="Reports" />
          {
            selectValues[user.roleId] === 'Admin' &&
            <>
              <div className={classes.separator}/>
              <TabLink to="/users" label="users" />
            </>
          }
        </div>
      </Header>
      <section className={classes.body}>{children}</section>
      <Footer withInterview={false} />
    </>
  );
};

export default PrivatePage;
